export default "__VITE_ASSET__b44763ed__"